export const callbackOnKeyboardEvent = (
  event: any,
  keyName: string,
  callback: Function
) => {
  if (event.key === keyName) {
    callback();
  }
};
